import { parseAgeRange } from '@/utilities/bruteForce'
import { addId } from '@/utilities/functions'
import store from '@/plugins/store'

const getCityUrl = result => {
  return `${getTrialUrl(result)}#locations`
}
const getTrialUrl = result => {
  return `/trial-details/trial-detail?trialId=${result?.id}&location=${userLocation}&distance=`
}

export const isloaded = () =>{
  return store.getters['core/isLoading']
  // return setTimeout(()=>{   return store.getters['core/isLoading']}, 1000)

}
export const searchResults =  context => {
  const response =  context.$store.getters['search/results']
  const data = response?.data || {}
  const { isLocationSearch, numFound, results = [] } = data
  const articles = results.map(r => ({
    ...r,
    age: parseAgeRange(r.participantsAgeRange || ''),
    cities: addId(r.locationCities?.map(c => ({ name: c, url: getCityUrl(r) })) || []),
    gender: r.participantsSex,
    lastUpdated: r.lastUpdatedDate,
    medicalConditions: r.condition,
    title: r.publicTitle,
    url: getTrialUrl(r),
  }))
  
  return { count: numFound?numFound:0, articles, isLocationSearch}
  
}

var URLquery = window.location.search;
var URLparams = new URLSearchParams(URLquery);
var userLocation = URLparams.get('location');
if(userLocation==null)
{
  userLocation="";
}

